import React, { useState } from "react";
import {
  Grid,
  AppBar,
  Toolbar,
  IconButton,
  Popper,
//   Hidden,
  Typography,
  MenuList,
  Grow,
  ClickAwayListener,
  MenuItem,
  Paper,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import InputIcon from "@mui/icons-material/Input";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import "../../css/layout.css";

const Header = ({ onSidebarOpen }) => {
  const [openMenu, setOpenMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const navigate = useNavigate();

  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
  };

  const closeMenu = () => {
    setAnchorEl(null);
    setOpenMenu(false);
  };

  const handleListKeyDown = (event) => {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpenMenu(false);
    }
  };

  const handleLogout = () => {
    localStorage.clear();
    navigate("/sign-in");
  };

  const username = localStorage.getItem("username");

  return (
    <AppBar className="topAppbar" position="sticky">
      <Toolbar className="topToolbar">
        {username && (
          <IconButton className="icons" onClick={onSidebarOpen} size="small">
            <MenuIcon />
          </IconButton>
        )}

        <Grid item lg={5}>
          <h1 className="mainTopbarHeading marginHorizontal-sm">
            Portfolio Management System
          </h1>
        </Grid>

        <div className="flexGrow" />

        {username && (
          <>
            {/* <Hidden mdDown> */}
              <AccountCircleIcon className="icons marginHorizontal-sm" />
              <Typography className="icons">
                {username.replace(/[_-]/g, " ").toUpperCase()}
              </Typography>
            {/* </Hidden> */}

            <IconButton onClick={handleMenu}>
              <ExpandMoreIcon className="icons" />
            </IconButton>

            <Popper
              open={openMenu}
              anchorEl={anchorEl}
              transition
              disablePortal
            >
              {({ TransitionProps, placement }) => (
                <Grow
                  {...TransitionProps}
                  style={{
                    transformOrigin:
                      placement === "bottom"
                        ? "center top"
                        : "center bottom",
                  }}
                >
                  <Paper>
                    <ClickAwayListener onClickAway={closeMenu}>
                      <MenuList
                        autoFocusItem={openMenu}
                        id="menu-list-grow"
                        onKeyDown={handleListKeyDown}
                      >
                        <MenuItem onClick={handleLogout}>
                          <InputIcon className="standard-icons" />
                          <Typography className="marginHorizontal-sm">
                            Logout
                          </Typography>
                        </MenuItem>
                      </MenuList>
                    </ClickAwayListener>
                  </Paper>
                </Grow>
              )}
            </Popper>
          </>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
